
export class SetLanguage {
  static readonly type = '[Language] Set Language';
  constructor(public language: string) {}
}

export class GetLanguage {
  static readonly type = '[Language] Get Language';
}
